<template>
  <div class="">
    <AppDataProperty
      contentId="appInfo"
      @dataAvailable="
        data => {
          if (!data?.metaData) return
          appInfo = data?.metaData
        }
      "
    />
    <AppDataProperty
      contentId="affiliationData"
      @dataAvailable="
        data => {
          if (!data?.metaData) return
          affiliationData = data?.metaData
        }
      "
    />
    <div
      class="boxComponent -mt-20 bg-slate-100 px-6 py-6 flex justify-between items-center overflow-auto relative"
    >
      <div
        class="absolute w-full h-full left-0 top-0 opacity-100 overflow-hidden"
      >
        <div
          class="absolute w-full h-full top-0 left-0 bg-[#0375B9] opacity-100"
        ></div>
        <div
          class="absolute w-[150px] h-[150px] -right-[40px] -top-[20px] -rotate-[30deg] opacity-30"
        >
          <img
            src="~@/assets/images/all/bonus.svg"
            alt=""
            class="w-full h-full object-cover object-top"
          />
        </div>
      </div>
      <div class="relative">
        <div class="text-[#B4D6EA] text-xs font-bold">Solde</div>
        <div class="text-white">
          <span class="text-5xl font-bold">
            {{ affiliationData?.amount }}
          </span>
          <span class="text-2xl font-bold text-[#B4D6EA]"> FCFA </span>
        </div>
        <div class="py-1"></div>
        <div class="text-sm text-primary-200 w-[70%]">
          Obtenez les bonus de <span class="font-bold text-white">1%</span> sur les <span class="underline">dépots réussis</span> et <span class="font-bold text-white">5%</span> sur les <span class="underline">abonnements effectués</span> 
          <!-- <span v-html="appInfo?.affiliationDetailText || ''"></span> -->
        </div>
        <div class="py-2"></div>
        <div class="flex gap-4">
          <button
            @click="getBonus"
            class="buttonComponent bg-none !bg-white small shadow-none !py-3 !px-4 text-[#002E5E]"
          >
            <div class="flex gap-2 items-center">
              <div class="w-5 h-5">
                <img
                  src="~@/assets/images/all/withdraw.svg"
                  alt=""
                  class="w-full h-full"
                />
              </div>
              <div>Retirer le bonus</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AppDataProperty from '../AppDataProperty.vue'

export default defineComponent({
  name: 'UserStats',
  components: { AppDataProperty },
  props: {},
  data() {
    return {
      affiliationData: {},
      appInfo: {},
    }
  },
  mounted() {},
  methods: {
    getBonus() {
      if (this.affiliationData?.amount == 0) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Partagez Kingrecharge',
          body: "Partagez kingRecharge pour recevoir des bonus d'affiliation",
        })
        return
      }
      this.$router.back()
      setTimeout(() => {
        this.$Events.dispatchEvent('service_launching_requested', {
          serviceId: 'affiliation',
        })
      }, 800)
    },
  },
})
</script>
